<template>
    <Rattachment :inverse="true" />
</template>

<script>
import Rattachment from './Rattachment';

export default {
    components: {
        Rattachment,
    },
};
</script>
